// @mui
import { styled } from '@mui/material/styles';
import { ListItemIcon, ListItemButton } from '@mui/material';

// ----------------------------------------------------------------------

// eslint-disable-next-line max-len
export const StyledNavItem = styled((props) => <ListItemButton disableGutters {...props} />)(({ theme }) => ({
  ...theme.typography.body2,
  fontSize: '16 !important',
  fontFamily: 'Whitney !important',
  height: 48,
  position: 'relative',
  textTransform: 'capitalize',
  color: theme.palette.text.secondary,
  borderTopRightRadius: 6,
  borderBottomRightRadius: 6,
}));



export const StyledNavItemIcon = styled(ListItemIcon)({
  width: 15,
  height: 15,
  paddingRight: 15,
  color: 'inherit',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});
